import { useState } from "react";
import "./accordion.scss";

export default function Accordion({ title, children }) {
    const [isOpen, setIsOpen] = useState(false);

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="accordion">
            <div className="accordion__header" onClick={toggleAccordion}>
                <div className="accordion__title">{title}</div>
                <div className={`accordion__icon ${isOpen ? "open" : ""}`}>
                    {isOpen ? "-" : "+"}
                </div>
            </div>
            {isOpen && <div className="accordion__content">{children}</div>}
        </div>
    );
}
